import React from 'react'
import error404 from '../../assets/images/error-404.svg'
import { NavLink } from 'react-router-dom'
import { Button } from '@/components/ui/button'


export const NotFound = () => {
    return (
        <div className='mx-auto w-full max-w-2xl rounded-xl border bg-card p-8 text-center shadow-sm'>
            <div className='space-y-6'>
                <img className='mx-auto max-h-64 w-full max-w-sm object-contain' src={error404} alt='' />
                <div className='mx-auto max-w-lg'>
                    <h3 className='text-xl font-semibold text-foreground'>
                        Nội dung truy cập không tồn tại hoặc đang phát triển !!!
                    </h3>
                    <Button asChild className='mt-4'>
                        <NavLink to='/'>Trở lại trang chủ</NavLink>
                    </Button>
                </div>
            </div>
        </div>
    )
}